import MultiLineHeader from '../components/DataTable/MultiLineHeader';
import HorseSireCell from '../components/DataTable/HorseSireCell';
import DamDamSireCell from '../components/DataTable/DamDamSireCell';
import ExpandCell from '../components/DataTable/ExpandCell';
import ResponsiveHeader from '../components/DataTable/ResponsiveHeader';
import ResponsiveCell from '../components/DataTable/ResponsiveCell';

const DATA_TITLE = 'data-title';
const rootData = document.getElementById('root').dataset || {};

/**
 * Config for upcoming sales table
 */
export default {
    url: `/bloodstock/sales/catalogues/${rootData.venueid}/${rootData.salesdate}/data.json`,
    primaryColumn: 'lot_no',
    activeLot: rootData.lot,
    lotLetter: rootData.lotLetter,
    venueUid: rootData.venueid,
    initialPage: rootData.page,
    columns: [
        {
            columnName: '_spacer',
            displayName: '',
            headerDataAttrs: {
                [DATA_TITLE]: 'expand'
            },
            customCell: ExpandCell
        },
        {
            columnName: 'lot_no',
            headerDataAttrs: {
                [DATA_TITLE]: 'lotNo'
            },
            customHeader: {
                component: ResponsiveHeader,
                options: {
                    displayName: [
                        {
                            className: '',
                            displayName: 'Lot '
                        },
                        {
                            className: 'hidden-lg-down',
                            displayName: 'No'
                        }
                    ]
                }
            }
        },
        {
            columnName: 'horse_style_name',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Horse name'
                        },
                        {
                            text: 'Sire',
                            className: 'hidden-sm-down'
                        }
                    ]
                }
            },
            customCell: {
                component: HorseSireCell,
                options: {
                    horseUid: 'horse_uid',
                    horseName: 'horse_style_name',
                    sireUid: 'sire_uid',
                    sireName: 'sire_style_name',
                    entered: 'entered',
                    breakClassName: 'hidden-sm-down',
                    sireClassName: 'hidden-sm-down'
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'horse-name'
            }
        },
        {
            columnName: 'horse_first_colour_code',
            displayName: 'Col',
            headerDataAttrs: {
                [DATA_TITLE]: 'colour'
            }
        },
        {
            columnName: 'horse_sex',
            displayName: 'Sex',
            headerDataAttrs: {
                [DATA_TITLE]: 'sex'
            }
        },
        {
            columnName: 'horse_age',
            displayName: 'Age',
            headerDataAttrs: {
                [DATA_TITLE]: 'age'
            }
        },
        {
            columnName: 'dam_style_name',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: ['Dam', 'Dam\'s sire']
                }
            },
            customCell: {
                component: DamDamSireCell,
                options: {
                    damUid: 'dam_uid',
                    damName: 'dam_style_name',
                    damSireUid: 'sire_of_dam_uid',
                    damSireName: 'sire_of_dam_style_name'
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'dam-sire'
            }
        },
        {
            columnName: 'seller_name',
            displayName: 'Vendor',
            headerDataAttrs: {
                [DATA_TITLE]: 'seller-name'
            }
        },
        {
            columnName: 'price',
            displayName: 'Price',
            headerDataAttrs: {
                [DATA_TITLE]: 'price'
            },
            customCell: {
                component: ResponsiveCell,
                options: {
                    columns: [
                        {
                            name: 'price_styled_long'
                        }
                    ]
                }
            }
        },
        {
            columnName: 'buyer_detail',
            displayName: 'Buyer',
            headerDataAttrs: {
                [DATA_TITLE]: 'buyer-detail'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/salesResultsTable.js